<section class="recently-viewed-facet">
    <h5>{{ this.title }}</h5>
    <div class="content-area">
        <ul *ngIf="facetValues && facetValues?.length > 0; else noRecentlyViewed">
            @for (facetValue of facetValues; track facetValue.value) {
                <li>
                    <div class="facet-list-item">
                        <span class="facet-value">
                            <mat-icon [svgIcon]="'rewind_clock'" aria-hidden></mat-icon>
                            <button
                                matTooltip="Click {{ facetValue.value }} to view in modal"
                                [matTooltipShowDelay]="1000"
                                [matTooltipHideDelay]="2000"
                                aria-haspopup="dialog"
                                (click)="handleOpenDialog(facetValue.value)">
                                <span class="text-content">{{ facetValue.value }}</span>
                            </button>
                        </span>
                    </div>
                </li>
            }
        </ul>
        <ng-template #noRecentlyViewed>
            <div class="no-queries-message"> No recent views found. </div>
        </ng-template>
    </div>
    <div class="buttons-container">
        <button
            *ngIf="canShowMore()"
            matTooltip="Show More Items"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000"
            (click)="showMore()"
            >+ Show more
        </button>

        <button
            *ngIf="canShowLess()"
            matTooltip="Show Less Items"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000"
            (click)="showLess()"
            >- Show less
        </button>

        <button
            *ngIf="facetValues.length > 0"
            matTooltip="Clear all"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000"
            (click)="clearSelections()"
            >Clear all
        </button>
    </div>
</section>
